export const remToPx = (remValue: string, baseFontSize = 16): number => {
  const numericPart = parseFloat(remValue);
  if (isNaN(numericPart)) {
    console.error("Invalid REM value");
    return 0;
  }
  return numericPart * baseFontSize;
};
